/**
 * 사전
 */
import { Fragment } from 'react';
import { useLoaderData, useSearchParams } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { ALIAS, CUR_NETWORK, FILTER_DATA, NETWORK } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import NoData from '../../components/contents/common/NoData';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import { useOption } from '@hooks/useOption';
import FilterWrap from '@components/contents/common/FilterWrap';
import DictionaryArticle from '@components/contents/article/DictionaryArticle';
import Paging from '@components/contents/common/Paging';
import type { IContentData, IDictionary, ILoaderData } from '@type/index';

export const DictionaryLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<IDictionary | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.DICTIONARY));

    if (!searchParams?.keyword) {
      return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.DICTIONARY, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getDictionary?.initiate({ option, params: searchParams }));
  };

interface IFilterComponentProps {
  count: number;
  serviceAlias: string;
}
const FilterComponent = ({ count, serviceAlias }: IFilterComponentProps) => {
  return (
    <Header totalCount={count}>
      <FilterWrap filterDataObj={serviceAlias ? FILTER_DATA[serviceAlias][ALIAS.DICTIONARY] : {}} />
    </Header>
  );
};

interface IContentComponentProps {
  data: IContentData<IDictionary>;
  option: IOption;
}
const ContentComponent = ({ data, option }: IContentComponentProps) => {
  const [searchParams] = useSearchParams();
  const l10n = useAppSelector(selectL10N);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <DictionaryArticle item={item} l10n={l10n!} searchParams={searchParams} option={option} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const Dictionary = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<IDictionary>>) || {};
  const option = useOption();
  console.log('Dictionary Data', data);

  return (
    <div className="search-result dictionary">
      <FilterComponent count={data?.pagination?.total} serviceAlias={option.serviceAlias} />
      {!isError && Array.isArray(data?.list) && data?.list?.length > 0 ? <ContentComponent data={data} option={option} /> : <NoData />}
    </div>
  );
};

export default Dictionary;
